import React, { useEffect, useState } from 'react';
import config from '@/lib/config';
import { NextNavigationData } from '@/modules/types/navigation';
import { errorHandler } from '@/lib/Error';
import { ErrorState } from './errorState';

/** Check updates based on this documentation https://elmolearning.atlassian.net/wiki/spaces/RPM/pages/4040491068/EDS+Nav+Menu+Integration+Guide+menu-next */
/** Remove comment above once implementation for NextNavigation is finalized. */
type MenuNextProps = {
  navigationData?: NextNavigationData;
};

type MenuNextGlobal = {
  render: (renderProps: unknown) => void;
  setNavigationData: (data: unknown) => void;
};

export const MenuNext = ({ navigationData }: MenuNextProps) => {
  const [isScriptLoaded, setIsScriptLoaded] = useState(false);
  const [errorState, setErrorState] = useState<any>(null);

  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'module';
    script.src = config.NextMenuUrl;
    script.crossOrigin = 'anonymous';

    script.onerror = () => {
      const error = new Error(
        'Error on loading Next navigation menu external component.',
      );
      errorHandler(error, { componentStack: 'MenuNext' });
      setErrorState(error);
    };

    script.onload = () => {
      try {
        // @ts-expect-error MenuNext is expected to be globally available after script load
        window.MenuNext.render({
          rootElement: document.getElementById('elmo-navigation-menu'),
          autoFetchNavigationData: false,
        });

        setIsScriptLoaded(true);
      } catch (error: any) {
        errorHandler(error, { componentStack: 'MenuNext' });
        setErrorState(error);
      }
    };

    document.body.appendChild(script);

    return () => {
      if (script && script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);

  useEffect(() => {
    if (isScriptLoaded && navigationData) {
      // @ts-expect-error MenuNext is expected to be globally available after script load
      const MenuNextComponent = window.MenuNext as MenuNextGlobal;
      if (MenuNextComponent) {
        MenuNextComponent.setNavigationData(navigationData);
      } else {
        setErrorState(new Error('MenuNext is not defined'));
      }
    }
  }, [isScriptLoaded, navigationData]);

  return errorState ? <ErrorState /> : <div id="elmo-navigation-menu" />;
};
